import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { connect } from 'react-redux';
import { setNodeActive } from '../../stores/actions/nodeActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined.js';

const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};

interface IDeActivateNodeCardProps {
	hideAlert: () => void;
	nodeID: number;
    nodeName: string;
    active: boolean;
    updatedViaWebsiteAt: string;
    setNodeActive: (nodeID: number, active: boolean, updatedViaWebsiteAt: string) => void;
}

const DeActivateNodeCard  = (props: IDeActivateNodeCardProps) => {
    const {hideAlert, nodeID, nodeName, setNodeActive, active, updatedViaWebsiteAt} = props;

    const onSubmit = () => {
        setNodeActive(nodeID, !active, updatedViaWebsiteAt);
        hideAlert();
    };

    const confirmButton = () => {
        return(
            <Button
                color='info'
                onClick={onSubmit}
                className='downloadButton'
                style={{width: '30%'}}>
                OK
            </Button>);
    }

    const cancelButton = () => {
        return(
            <Button
                color='danger'
                onClick={hideAlert}
                className='downloadButton' 
                style={{marginLeft: '5px', width: '30%'}}>
                Cancel
            </Button>);
    }
    return (
        <ErrorComponent Children message='Error'>
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                   <CheckBoxOutlined/>
                </CardIcon>
                <p style={{ ...style.cardCategory, textAlign: 'left' }}>Toggle node's state</p>
                <h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{nodeName}</h3>
            </CardHeader>
            <CardBody>
                <GridContainer style={{ margin: '0 0 0 -15px' }}>
                    <h5 style={{ ...style.cardTitle, marginLeft: '10%', marginRight: '10%' }}>
                        {`Are you sure you want to ${active ? 'deactivate' : 'activate'} node?`}
                    </h5>
                    <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                        {confirmButton()}
                        {cancelButton()}
                    </GridItem>
                </GridContainer>
        </CardBody >
        </Card>
    </ErrorComponent>
    );
}


const actions = { setNodeActive };
export const ExportCardWithStyles = dashboardStyle(DeActivateNodeCard);
export default connect(null, actions)(ExportCardWithStyles);
